export var BlendType;
(function (BlendType) {
    BlendType[BlendType["BLEND_DISABLE"] = 0] = "BLEND_DISABLE";
    BlendType[BlendType["BLEND_ENABLE_ALL"] = 1] = "BLEND_ENABLE_ALL";
    BlendType[BlendType["BLEND_ENABLE_SEPERATE"] = 2] = "BLEND_ENABLE_SEPERATE";
})(BlendType || (BlendType = {}));
